module.exports = __webpack_public_path__ + "static/media/laurel.4655e96c.svg";